
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import {
  HeaderNavigationLinkListComponent,
  HeaderNavigationLinkListComputed,
  HeaderNavigationLinkListMethods,
  HeaderNavigationLinkListData,
  HeaderNavigationLinkListProps,
} from '@owc-packages/Header/src/HeaderNavigationLinkList';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import headerMixin from '@owc-utils/Mixins/Header';
import headerListMixin from '@owc-utils/Mixins/HeaderListMixin';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as HeaderNavigationLinkListComponent).extend<
  HeaderNavigationLinkListData,
  HeaderNavigationLinkListMethods,
  HeaderNavigationLinkListComputed,
  HeaderNavigationLinkListProps
>({
  name: 'owc-header-navigation-link-list',
  components: {
    ValidationBoxWrapper,
  },
  mixins: [headerMixin, headerListMixin, OwcDataComponent],
});
